// src/components/ProRoute.jsx
import React from "react";
import { Navigate } from "react-router-dom";
import { useSubscription, DEV_OVERRIDE_EMAILS } from "../contexts/SubscriptionContext";
import { useAuth } from "../contexts/AuthContext";

export default function ProRoute({ children }) {
  const { currentUser } = useAuth();
  const {
    loading,
    isPro,
    isTrialActive,
    isDev,
  } = useSubscription();

  if (loading) return null; // or spinner

  const email = currentUser?.email?.toLowerCase() || "";

  // ⭐ DEV MODE = FULL ACCESS ALWAYS
  if (isDev || DEV_OVERRIDE_EMAILS.includes(email)) {
    console.log("🟣 ProRoute DEV OVERRIDE → ACCESS GRANTED:", email);
    return children;
  }

  // ⭐ Pro or active trial = full access
  const hasAccess = isPro || isTrialActive;

  if (!hasAccess) {
    console.log("🔐 ProRoute BLOCKED → requires Pro subscription.");
    return <Navigate to="/upgrade" replace />;
  }

  return children;
}
